module.exports = __webpack_public_path__ + "img/buyer.84393337.png";